export const UPDATE_SWAP_AND_BRIDGE_QUOTE_INTERVAL = 60000 // 1 minute
export const BRIDGE_STATUS_INTERVAL = 10000 // 10 seconds
export const ACTIVITY_REFRESH_INTERVAL = 5000 // 5 seconds
export const ACTIVE_EXTENSION_DEFI_POSITIONS_UPDATE_INTERVAL = 300000 // 5 minutes
export const ACTIVE_EXTENSION_PORTFOLIO_UPDATE_INTERVAL = 30 * 1000 // 30 seconds (ZKX: faster than upstream 2min)
export const INACTIVE_EXTENSION_PORTFOLIO_UPDATE_INTERVAL = 600000 // 10 minutes
export const LOCKED_EXTENSION_PORTFOLIO_UPDATE_INTERVAL = 4 * 60 * 60 * 1000 // 4 hours
export const SMART_ACCOUNT_IDENTITY_RETRY_INTERVAL = 300000 // 5 minutes
export const VIEW_ONLY_ACCOUNT_IDENTITY_GET_INTERVAL = 300000 // 5 minutes
export const ACCOUNT_STATE_STAND_BY_INTERVAL = 300000 // 5 minutes
export const NETWORKS_UPDATE_INTERVAL = 8 * 60 * 60 * 1000 // 8 hrs
export const BLACKLIST_UPDATE_INTERVAL = 8 * 60 * 60 * 1000 // 8 hrs
export const PHISHING_INACTIVE_UPDATE_INTERVAL = 6 * 60 * 60 * 1000 // 6 hrs
export const PHISHING_ACTIVE_UPDATE_INTERVAL = 15 * 60 * 1000 // 15 minutes
export const PHISHING_FAILED_TO_GET_UPDATE_INTERVAL = 600000 // 10 minutes
export const ESTIMATE_UPDATE_INTERVAL = 30000
export const GAS_PRICE_UPDATE_INTERVAL = 12000
/**
 * While no wallet view is open SignAccountOp skips gas price fetches; it re-checks
 * this often so prices refresh as soon as a view opens again (no RPC call is made).
 */
export const GAS_PRICE_NO_VIEW_RECHECK_INTERVAL = 1000
/**
 * How long GasPriceController stays quiet after surfacing a gas price failure.
 * The fetch itself retries every GAS_PRICE_UPDATE_INTERVAL; without this the same
 * error toast is re-raised every 12s for as long as the chain's RPC is broken.
 */
export const GAS_PRICE_ERROR_REEMIT_INTERVAL = 5 * 60 * 1000 // 5 minutes
export const FETCH_SAFE_TXNS = 3 * 60 * 1000 // 3 minutes
